import { PanelType } from '@fluentui/react';
import { ActionButton, DefaultButton, IconButton, PrimaryButton } from 'office-ui-fabric-react/lib/Button';
import { CommandBar } from 'office-ui-fabric-react/lib/CommandBar';
import { DetailsList, Selection, SelectionMode } from 'office-ui-fabric-react/lib/DetailsList';
import { ScrollablePane, ScrollbarVisibility } from 'office-ui-fabric-react/lib/ScrollablePane';
import { Stack } from 'office-ui-fabric-react/lib/Stack';
import React, { Component, Fragment } from 'react';
import Scriba from 'react-scriba';
import '../../css/immocom.css';
import { DataDocument } from '../../data/DataDocument.jsx';
import { DataDocumentOperation } from '../../data/DataDocumentOperation.jsx';
import { DataDocumentReservation } from '../../data/DataDocumentReservation.jsx';
import { Immocom } from '../../specifique/immocom';
import { EUIDialog } from '../EUI/EUIDialog';
import { EUIPanel } from '../EUI/EUIPanel';
import { DetailsListDocument } from '../List/DetailsListDocument';
import { ProgressIndicatorChargement } from '../Loader/ProgressIndicatorChargement';
import { MessageBars } from '../Outils/MessageBars';
import { FicheDocumentReservation } from './FicheDocumentReservation';
import { FicheDonneesReservation } from './FicheDonneesReservation';
import { FicheImportDocument } from './FicheImportDocument';
import { FicheSignatureDocument } from './FicheSignatureDocument';

export class FicheDossierClient extends Component {

    static defaultProps = {
        idOperation: 0,
        idReservation: 0,
        peutModifierBlocDossierClient: false,
        type: undefined, // Réservation ou Opération
        //onSuppressionDossierClient  // MG - 2344
    };

    static defaultState = {
        afficherDialogSuppressionDossierClient: false,
        afficherPanelDocumentReservation: false,
        afficherPanelDocuments: false,
        afficherPanelDonneesReservation: false,
        afficherPanelImportDocumentReservation: false,
        afficherPanelSignatureReservation: false,
        document: {},
        documentASigner: null,
        estAdminNational: false,
        estGestionnaireDeMandat: false,
        groupesDocuments: [],
        idOperation: 0,
        idReservation: 0,
        itemsSelectionnes: [],
        listDocuments: [],
        listDocumentsAImporter: [],
        peutSupprimerDocumentASigne: false,
        peutSupprimerDocumentDossierClientType: false,
        peutSupprimerDocumentSansSignature: false,
        peutSupprimerDocumentSigne: false,
    };

    constructor(props) {
        super(props);
        this.state = { ...FicheDossierClient.defaultState };
        this._selection = new Selection({ onSelectionChanged: this._onSelectionChanged });
        this._selectedIndices = [];
        this._chargementColonnes();
    };

    _onSelectionChanged = () => {
        // Définit l'ordre des documents pour la génération du document à signer
        const selection = this._selection;
        const selectedIndices = this._selectedIndices;
        const newSelectedIndices = selection.getSelectedIndices();
        const items = selection.getItems();
        let ordre;

        if (newSelectedIndices.length > 1) { // Dans le cas où plusieurs items sont sélectionnés
            if (selectedIndices.length < newSelectedIndices.length) { // Dans le cas d'une sélection
                ordre = selectedIndices.length;
                newSelectedIndices.filter(index => !selectedIndices.includes(index)).forEach( // Pour chacun des items nouvellement sélectionnés
                    (index) => {
                        ordre++; // Incrémenter l'indice courant
                        items[index].ordre = ordre; // Et l'affecter à l'item
                    }
                );
            }
            else if (this._selectedIndices.length > newSelectedIndices.length) { // Dans le cas d'une dé-sélection
                selectedIndices.filter(index => !newSelectedIndices.includes(index)).forEach( // Pour chacun des items dé-sélectionnés
                    (index) => {
                        ordre = items[index].ordre; // On mémorise l'ordre
                        items[index].ordre = undefined; // Lui retirer son indice
                    }
                );
                newSelectedIndices.filter(index => items[index].ordre > ordre).forEach( // Pour chacun des items sélectionnés dont l'ordre est supérieur à celui de l'item dé-sélectionné
                    (index) => {
                        items[index].ordre--; // Lui décrémenter son indice
                    }
                );
            }
        } else { // Dans le cas notamment d'une sélection + dé-sélection (= clic sur autre ligne)
            items.forEach(
                (item, index) => {
                    if (selection.isIndexSelected(index)) {
                        item.ordre = 1;
                    } else {
                        item.ordre = undefined;
                    }
                }
            );
        }

        this._selectedIndices = newSelectedIndices;
        this.setState({ itemsSelectionnes: items });
    };

    _chargementColonnes = () => {

        const { peutModifierBlocDossierClient, type } = this.props;
        const { estAdminNational, estGestionnaireDeMandat, peutSupprimerDocumentASigne, peutSupprimerDocumentDossierClientType, peutSupprimerDocumentSansSignature, peutSupprimerDocumentSigne } = this.state;

        let columns = [{
            className: 'ms-hiddenSm',
            fieldName: 'ordre',
            headerClassName: 'ms-hiddenSm',
            isResizable: true,
            key: 'ordre',
            minWidth: 35,
            maxWidth: 35,
            name: 'Ordre',
        }, {
            className: 'ms-hiddenSm',
            fieldName: 'rang',
            headerClassName: 'ms-hiddenSm',
            isResizable: true,
            key: 'rang',
            minWidth: 35,
            maxWidth: 35,
            name: 'Rang',
        }, {
            fieldName: 'nom',
            isResizable: true,
            key: 'nom',
            name: 'Nom',
        }, {
            className: 'ms-hiddenMdDown',
            fieldName: 'categorie',
            headerClassName: 'ms-hiddenMdDown',
            isResizable: true,
            key: 'categorie',
            minWidth: 100,
            maxWidth: 200,
            name: 'Catégorie',
        }, {
            className: 'ms-hiddenMdDown',
            fieldName: 'typeDocument',
            headerClassName: 'ms-hiddenMdDown',
            isResizable: true,
            key: 'typeDocument',
            minWidth: 150,
            maxWidth: 300,
            name: 'Sous catégorie',
        }, {
            className: 'ms-hiddenLgDown',
            fieldName: 'documentSigne',
            headerClassName: 'ms-hiddenLgDown',
            isResizable: true,
            key: 'documentSigne',
            minWidth: 90,
            maxWidth: 90,
            name: 'Signé électroniquement',
        }, {
            className: 'ms-hiddenLgDown',
            fieldName: 'etat',
            headerClassName: 'ms-hiddenLgDown',
            isResizable: true,
            key: 'etat',
            minWidth: 100,
            maxWidth: 200,
            name: 'Etat',
        }];

        if (peutModifierBlocDossierClient) {
            if (type === 'Réservation')
                columns.push({
                    iconName: '',
                    isIconOnly: true,
                    isResizable: true,
                    key: 'signer',
                    minWidth: 80,
                    maxWidth: 100,
                    onRender: item => item.etat && <ActionButton
                        ariaLabel="Signer le document"
                        disabled={!(item.etat === 'A SIGNER' || item.etat === 'SIGNING')}
                        iconProps={{ iconName: 'PenWorkspace' }}
                        onClick={() => this._onAffichagePanelFicheSignatureDocument(item)}
                        title="Signer le document"
                    >
                        Signer
                    </ActionButton>
                });

            columns.push({
                isIconOnly: true,
                key: 'monter',
                minWidth: 20,
                maxWidth: 20,
                onRender: item => item.rang && item.rang > 1 && <IconButton
                    ariaLabel="Monter dans la liste"
                    iconProps={{ iconName: 'SortUp' }}
                    onClick={() => this._onChangerOrdreDocument(item.rang, item.rang - 1)}
                    title="Monter dans la liste"
                />
            });

            columns.push({
                isIconOnly: true,
                key: 'descendre',
                minWidth: 20,
                maxWidth: 20,
                onRender: item => item.rang && item.rang < this.state.listDocuments.length && <IconButton
                    ariaLabel="Descendre dans la liste"
                    iconProps={{ iconName: 'SortDown' }}
                    onClick={() => this._onChangerOrdreDocument(item.rang, item.rang + 1)}
                    title="Descendre dans la liste"
                />
            });
        }

        columns.push({
            className: 'ms-hiddenSm',
            headerClassName: 'ms-hiddenSm',
            isIconOnly: true,
            key: 'telecharger',
            minWidth: 20,
            maxWidth: 20,
            onRender: item => <IconButton
                ariaLabel="Télécharger le document"
                iconProps={{ iconName: 'TextDocument' }}
                onClick={() => this._onTelechargementDocument(item.rowGUID)}
                title="Télécharger le document"
            />
        });

        if (peutModifierBlocDossierClient) {
            columns.push({
                isIconOnly: true,
                key: 'retirer',
                minWidth: 20,
                maxWidth: 20,
                onRender: item => {
                    const { etat } = item;

                    let peutRetirer = estAdminNational;
                    peutRetirer |= type === 'Opération' && peutSupprimerDocumentDossierClientType;
                    peutRetirer |= type === 'Réservation' && peutModifierBlocDossierClient && (
                        (etat === 'A SIGNER' && peutSupprimerDocumentASigne)
                        || (etat === 'SIGNE (Sauf EI)' && peutSupprimerDocumentSigne)
                        || (!etat && peutSupprimerDocumentSansSignature)
                    );
                    //MG - 16/08/2022 - 2036 - GestionnaireDeMandat peut modifier les docs SAUF le contrat de réservation signé électroniquement 
                    if (estGestionnaireDeMandat) peutRetirer &= etat !== 'SIGNE';

                    return !!peutRetirer && <IconButton
                        ariaLabel="Retirer du dossier client"
                        iconProps={{ iconName: 'Delete' }}
                        onClick={this._toggleDialog("SuppressionDossierClient", true, { document: item })}
                        title="Retirer du dossier client"
                    />;
                }
            });
        }

        this.columns = columns;

    };

    _getItems = () => {

        const { peutAjouterBlocDossierClient, type } = this.props;
        const { itemsSelectionnes } = this.state;

        let items = [];

        if (type === 'Réservation')
            items.push({
                iconProps: { iconName: 'Upload' },
                key: 'importerDocument',
                name: 'Importer des documents',
                onClick: this._togglePanel("ImportDocumentReservation", true)
            });

        if (peutAjouterBlocDossierClient)
            items.push({
                iconProps: { iconName: 'PageAdd' },
                key: 'ajoutDocumentBibliotheque',
                name: 'Ajouter un document à partir de la bibliothèque',
                onClick: type === 'Réservation' ? this._togglePanel("DocumentReservation", true) : this._togglePanel("Documents", true)
            });

        if (peutAjouterBlocDossierClient)
            items.push({
                iconProps: { iconName: 'Descending' },
                key: 'enregistrerRangDocuments',
                name: 'Enregistrer le classement des documents',
                onClick: this._onEnregistrementOrdreDocuments
            });

        if (type === 'Réservation')
            items.push({
                disabled: itemsSelectionnes.length <= 0,
                iconProps: { iconName: 'Edit' },
                key: 'creerDocumentASigner',
                name: 'Créer un document à signer',
                onClick: this._onGenereDocumentDossierClientReservation
            });

        return items;

    };

    _getFarItems = () => {
        return [
            {
                key: 'nombreEnregistrement',
                name: (this.state.listDocuments != null ? this.state.listDocuments.length : 0)
            }
        ];
    }

    _chargementDonnees = () => {
        let idReservationRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idReservation, [0, this.state.idReservation]);
        let idOperationRenseigneeEtDifferent = Immocom.getSiPropsRenseigneeEtDifferenteDeLaValeurEnParametre(this.props.idOperation, [0, this.state.idOperation]);

        if (this.props.type === 'Réservation') {
            if (idReservationRenseigneeEtDifferent && idOperationRenseigneeEtDifferent) {
                this._chargementDossierClientReservation();
            }
        }
        else {
            if (idOperationRenseigneeEtDifferent) {
                this._chargementDossierClientOperation();
            }
        }
    }

    _chargementDossierClientReservation = (affichageErreurPersistant) => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement des documents du dossier client'
        });

        var chargementDocumentDossierClient = DataDocumentReservation._chargementDocumentDossierClientReservation(this.props.idOperation, this.props.idReservation);

        chargementDocumentDossierClient
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;
                    let listeGroupesDocuments = [];
                    let listeDocuments = objetData[0];

                    if (listeDocuments.length > 0) {
                        let groupeDocumentTrav = listeDocuments[0].groupeDocument;
                        let nbGroupeDocument = 0;
                        let depart = 0;

                        listeDocuments.forEach(function (value, index) {
                            let groupeDocument = value.groupeDocument;

                            if (groupeDocument === groupeDocumentTrav) {
                                nbGroupeDocument++;
                            }
                            else {
                                listeGroupesDocuments.push({ key: groupeDocumentTrav, name: groupeDocumentTrav, startIndex: depart, count: nbGroupeDocument });

                                groupeDocumentTrav = groupeDocument;
                                depart = (depart + nbGroupeDocument);
                                nbGroupeDocument = 1;
                            }

                            if (index === (objetData[0].length - 1)) {
                                // Dernier de la liste
                                listeGroupesDocuments.push({ key: groupeDocumentTrav, name: groupeDocumentTrav, startIndex: depart, count: nbGroupeDocument });
                            }
                        });
                    }

                    let stateTemp = {};
                    stateTemp.idReservation = this.props.idReservation;
                    stateTemp.idOperation = this.props.idOperation;
                    stateTemp.listDocuments = objetData[0];
                    stateTemp.groupesDocuments = listeGroupesDocuments;
                    stateTemp.peutSupprimerDocumentASigne = objetData[1];
                    stateTemp.peutSupprimerDocumentSigne = objetData[2];
                    stateTemp.peutSupprimerDocumentSansSignature = objetData[3];
                    //stateTemp.peutModifierBlocDossierClient = this.props.peutModifierBlocDossierClient;
                    stateTemp.estAdminNational = objetData[4];
                    stateTemp.estGestionnaireDeMandat = objetData[5]


                    //AF - Ticket 1456
                    if (affichageErreurPersistant == true) {
                        stateTemp.enCoursDeTraitement = false;
                        stateTemp.messageEnCoursTraitement = '';
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp, false);
                    } else {
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                    }
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _chargementDossierClientOperation = () => {
        this.setState({
            enCoursDeTraitement: true,
            messageEnCoursTraitement: 'Chargement du dossier client type'
        });

        var chargementDocumentDossierClientOperation = DataDocumentOperation._chargementDocumentDossierClientOperation();

        chargementDocumentDossierClientOperation
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;

                    let stateTemp = {};
                    stateTemp.idOperation = objetData[0];
                    stateTemp.listDocuments = objetData[1];
                    stateTemp.groupesDocuments = undefined; //On affiche les regroupements uniquement depuis la résa
                    stateTemp.peutSupprimerDocumentDossierClientType = objetData[2];

                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onEnregistrementOrdreDocuments = () => {
        if (this.props.type === 'Réservation') {
            let idOperation = this.props.idOperation;
            let idReservation = this.props.idReservation;

            if (idOperation > 0 && idReservation > 0) {
                this.setState({
                    enCoursDeTraitement: true,
                    messageEnCoursTraitement: 'Enregistrement du classement des documents du dossier client'
                });

                var enregistrementRangDocumentDossierClientReservation = DataDocumentReservation._onEnregistrementRangDocumentDossierClientReservation(idOperation, idReservation, this.state.listDocuments);

                enregistrementRangDocumentDossierClientReservation
                    .then(responseFetch => {
                        let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                        if (retourVerif === null) {
                            let objetData = responseFetch.reponseAPIobjet;

                            Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });

                            if (objetData === null) {
                                this._chargementDossierClientReservation();
                            }
                        }
                        else {
                            Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                        }
                    });
            }
        }
        else {
            let idOperation = this.state.idOperation || 0;

            // KP 19/03/2020 : si idOperation === 0 alors le contrôleur tentera de le déterminer via les variables de session
            //if (idOperation > 0) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Enregistrement du classement des documents du dossier client'
            });

            var enregistrementRangDocumentDossierClientOperation = DataDocumentOperation._onEnregistrementRangDocumentDossierClientOperation(idOperation, this.state.listDocuments);

            enregistrementRangDocumentDossierClientOperation
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let objetData = responseFetch.reponseAPIobjet;

                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });

                        if (objetData === null) {
                            this._chargementDossierClientOperation();
                        }
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
            //}
        }
    }

    //****************************************
    //dédié à l'opération
    //****************************************
    _onEnregistrementImportDocument = () => {
        let idOperation = this.state.idOperation;

        if (idOperation > 0) {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Enregistrement des documents dans le dossier client'
            });

            var enregistrementDocumentDossierClientOperation = DataDocumentOperation._onEnregistrementDocumentDossierClientOperation(idOperation, this.state.listDocumentsAImporter);

            enregistrementDocumentDossierClientOperation
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        this._togglePanel("Documents", false)();
                        this._onEnregistrementOrdreDocuments();
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, { ...this.state });
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }
                });
        }
    }

    _onSuppressionDossierClient = () => {
        if (this.props.type === 'Réservation') {
            if (this.state.idOperation > 0 && this.state.idReservation > 0) {
                this.setState({
                    enCoursDeTraitement: true,
                    messageEnCoursTraitement: 'Suppression du document du dossier client'
                });

                var suppressionDocumentDossierClientReservation = DataDocumentReservation._onSuppressionDocumentDossierClientReservation(this.state.idOperation, this.state.idReservation, this.state.document.idTemplate, this.state.document.idInstance, this.state.document.rowGUID);

                suppressionDocumentDossierClientReservation
                    .then(responseFetch => {
                        let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                        if (retourVerif === null) {
                            Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, {});
                            this._chargementDossierClientReservation();
                            //this.props.onSuppressionDossierClient(); //MG - 2344
                        }
                        else {
                            Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                        }
                    });
            }
        }
        else {
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Suppression du document du dossier client'
            });

            var suppressionDocumentDossierClientOperation = DataDocumentOperation._onSuppressionDocumentDossierClientOperation(this.state.idOperation, this.state.document.idTemplate, this.state.document.idInstance, this.state.document.rowGUID);

            suppressionDocumentDossierClientOperation
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, {});
                        this._chargementDossierClientOperation();
                    }
                    else {
                        Immocom.onTraitementErreurAvecState(this, {}, retourVerif, responseFetch);
                    }
                });
        }
    }

    _onTelechargementDocument = (rowGUID) => {
        var telechargementDocument = DataDocument._onTelechargementDocument(rowGUID);

        telechargementDocument
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let objetData = responseFetch.reponseAPIobjet;
                    let document = Scriba.fichier().Base64VersByteArray(objetData.fileData);

                    return Scriba.fichier().EnregisterSous(document, objetData.nom);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onChangerOrdreDocument = (rangDepart, rangArrivee) => {
        if (rangDepart !== null && rangArrivee !== null) {
            let listDocumentsTrav = this.state.listDocuments;

            if (listDocumentsTrav.length > 0) {
                listDocumentsTrav[rangDepart - 1].rang = rangArrivee;
                listDocumentsTrav[rangArrivee - 1].rang = rangDepart;
            }

            this.setState({ listDocuments: listDocumentsTrav.sort(function (a, b) { return a.rang - b.rang }) });

            this._selection.setAllSelected(false);
        }
    }

    _onGenereDocumentDossierClientReservation = () => {
        if (this.props.idOperation > 0 && this.props.idReservation > 0) {
            let listRowGUID = '';

            this._selection.getSelection().map(function (document) {
                let selection = document.ordre + '-GUID-' + document.rowGUID;

                if (listRowGUID === '') {
                    listRowGUID = selection;
                }
                else {
                    listRowGUID += ';#' + selection;
                }
            });

            //******************************************
            //implémenter la génération
            //******************************************
            this.setState({
                enCoursDeTraitement: true,
                messageEnCoursTraitement: 'Génération du document à signer'
            });

            var genererDocumentDossierClientReservation = DataDocumentReservation._onGenererDocumentDossierClientReservation(this.props.idOperation, this.props.idReservation, listRowGUID);
            var affichageErreurPersistant = false

            genererDocumentDossierClientReservation
                .then(responseFetch => {
                    let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                    if (retourVerif === null) {
                        let stateTemp = {};
                        stateTemp.idReservation = this.props.idReservation;
                        stateTemp.idOperation = this.props.idOperation;
                        Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                    }
                    else {
                        affichageErreurPersistant = true;
                        Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                    }

                    //AF - Ticket 1456 - On recharge systematiquement car on peut renvoyer une erreur mais le dossier sera correctement généré
                    this._chargementDossierClientReservation(affichageErreurPersistant);
                });
        }
    }

    _onAffichagePanelFicheSignatureDocument = (document) => {
        var signatureEDOC = DataDocumentReservation._onSignatureEDOC(this.state.idReservation, this.state.idOperation, document.rowGUID);

        signatureEDOC
            .then(responseFetch => {
                let retourVerif = Immocom.onRegardeSiOnChargeLesDonnees(responseFetch, this);

                if (retourVerif === null) {
                    let stateTemp = {};
                    stateTemp.afficherPanelSignatureReservation = true;
                    stateTemp.documentASigner = document;
                    Immocom.onReinitStateValeurParDefautEtExecutionDuSetState(this, stateTemp);
                }
                else {
                    Immocom.onTraitementErreurAvecState(this, { ...this.state }, retourVerif, responseFetch);
                }
            });
    }

    _onChargementEtatReservation = () => {
        this.props.onChargementEtatFicheReservation();
    }

    _toggleDialog = (nomDialog, isOpen, stateUpdates, callback) => () => {
        stateUpdates = stateUpdates || {};
        this.setState(
            {
                [`afficherDialog${nomDialog}`]: isOpen,
                ...stateUpdates
            },
            !!callback && typeof callback === "function" ? callback() : null
        );
    };

    _togglePanel = (nomPanel, isOpen, stateUpdates, callback) => () => {
        stateUpdates = stateUpdates || {};
        this.setState(
            {
                [`afficherPanel${nomPanel}`]: isOpen,
                ...stateUpdates
            },
            !!callback && typeof callback === "function" ? callback() : null
        );
    };

    componentDidMount = () => {
        // Ouverture depuis un onglet dans la fiche réservation
        if (this.props.type === 'Réservation') {
            if (this.props.idReservation !== 0 && this.props.idOperation !== 0) {
                this._chargementDossierClientReservation();
            }
        }
        else {
            this._chargementDossierClientOperation();
        }
    };

    componentDidUpdate = (prevProps, prevState) => {
        const { peutModifierBlocDossierClient } = this.props;
        const { estAdminNational, estGestionnaireDeMandat, peutSupprimerDocumentASigne, peutSupprimerDocumentDossierClientType, peutSupprimerDocumentSansSignature, peutSupprimerDocumentSigne } = this.state;
        if (!!peutModifierBlocDossierClient !== !!prevProps.peutModifierBlocDossierClient
            || !!estAdminNational !== !!prevState.estAdminNational
            || !!estGestionnaireDeMandat !== !!prevState.estGestionnaireDeMandat
            || !!peutSupprimerDocumentASigne !== !!prevState.peutSupprimerDocumentASigne
            || !!peutSupprimerDocumentDossierClientType !== !!prevState.peutSupprimerDocumentDossierClientType
            || !!peutSupprimerDocumentSansSignature !== !!prevState.peutSupprimerDocumentSansSignature
            || !!peutSupprimerDocumentSigne !== !!prevState.peutSupprimerDocumentSigne
        ) {
            this._chargementColonnes();
            this.forceUpdate();
        }
    };

    render = () => {

        const { idOperation, idReservation, type } = this.props;
        const {
            afficherDialogSuppressionDossierClient, afficherPanelDocumentReservation, afficherPanelDocuments, afficherPanelDonneesReservation, afficherPanelImportDocumentReservation, afficherPanelSignatureReservation,
            documentASigner, groupesDocuments, listDocuments, listDocumentsAImporter
        } = this.state;

        return <Fragment>

            {this.state.enCoursDeTraitement ? <ProgressIndicatorChargement label={this.state.messageEnCoursTraitement} /> : null}

            <Stack verticalFill>
                <CommandBar
                    items={this._getItems()}
                    overflowButtonProps={{ ariaLabel: 'Plus de fonctionnalités' }}
                    farItems={this._getFarItems()}
                    ariaLabel={'Utiliser les flèches droite et gauche pour naviguer'}
                />
                <MessageBars
                    errorMessage={this.state.errorMessage}
                    warningMessage={this.state.warningMessage}
                    onDismissErrorMessage={() => this.setState({ errorMessage: "" })}
                    onDismissWarningMessage={() => this.setState({ warningMessage: "" })}
                />
                <div className="position-relative h-100">
                    <ScrollablePane scrollbarVisibility={ScrollbarVisibility.auto}>
                        <DetailsList
                            items={listDocuments}
                            groups={groupesDocuments}
                            groupProps={{ showEmptyGroups: true }}
                            columns={this.columns}
                            selectionMode={SelectionMode.multiple}
                            selection={this._selection}
                            selectionPreservedOnEmptyClick
                        />
                    </ScrollablePane>
                </div>
            </Stack>

            <EUIPanel
                headerText="Bibliothèque de documents"
                isFormValid={listDocumentsAImporter.length > 0}
                isOpen={afficherPanelDocuments}
                onDismiss={this._togglePanel("Documents", false, {}, this._chargementDossierClientOperation)}
                onOpen={this._chargementDonnees}
                onSave={this._onEnregistrementImportDocument}
                styles={{ content: { height: "100%", padding: 0 } }}
                type={PanelType.extraLarge}
            >
                <DetailsListDocument
                    onSelection={(documents) => this.setState({ listDocumentsAImporter: documents })}
                    origine="DossierClient"
                />
            </EUIPanel>

            <FicheDocumentReservation
                idOperation={idOperation}
                idReservation={idReservation}
                onAffichePanelDocumentReservation={afficherPanelDocumentReservation}
                onFermeFicheDocumentReservation={this._togglePanel("DocumentReservation", false, {}, this._chargementDossierClientReservation)}
            />

            <FicheDonneesReservation
                idOperation={idOperation}
                idReservation={idReservation}
                onAffichePanelDonneesReservation={afficherPanelDonneesReservation}
                onFermeFicheDonneesReservation={this._togglePanel("DonneesReservation", false, {}, this._chargementDossierClientReservation)}
            />

            <FicheSignatureDocument
                affichagePanelSignatureDocument={afficherPanelSignatureReservation}
                documentASigner={documentASigner}
                idOperation={idOperation}
                idReservation={idReservation}
                onChargementEtatReservation={this._onChargementEtatReservation}
                onFermeFicheSignatureDocument={this._togglePanel("SignatureReservation", false, { documentASigner: null }, type === 'Réservation' ? this._chargementDossierClientReservation : null)}
            />

            <FicheImportDocument
                idOperation={idOperation}
                idReservation={idReservation}
                onAffichePanelImportDocument={afficherPanelImportDocumentReservation}
                onFermeFicheImportDocument={this._togglePanel("ImportDocumentReservation", false, {}, this._chargementDossierClientReservation)}
            />

            <EUIDialog
                buttons={[
                    <PrimaryButton key="delete" onClick={this._toggleDialog("SuppressionDossierClient", false, {}, this._onSuppressionDossierClient)} text="Supprimer" />,
                    <DefaultButton key="cancel" onClick={this._toggleDialog("SuppressionDossierClient", false)} text="Annuler" />
                ]}
                isOpen={afficherDialogSuppressionDossierClient}
                onDismiss={this._toggleDialog("SuppressionDossierClient", false)}
                titre="Suppression du document du dossier client"
            >
                Confirmez-vous la suppression de ce document du dossier client ?
            </EUIDialog>

        </Fragment>;

    };

};